/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CourseState } from './CourseState';
const PatchCourseDataParser = /* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ codecOptional(codecString)],
    ['state', /* #__PURE__ */ codecOptional(CourseState)],
]);
export class PatchCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchCourseDataParser.decode(input).map(res => new PatchCourseData(res));
    }
    static unsafeDecode(input) {
        return PatchCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchCourseDataParser.encode(data);
    }
    static schema() {
        return PatchCourseDataParser.schema();
    }
}
